import { useState } from 'react';

const BurgerMenu = (props) => {
    const [isOpen, setIsOpen] = useState(false);
    const toggleMenu = () => { setIsOpen(!isOpen); }

    return (
        <>
            <button className={`burger-menu-toggle ${isOpen ? 'active' : ''}`} onClick={toggleMenu}>
                <span></span>
                <span></span>
                <span></span>
            </button>
            <div className={`burger-menu ${isOpen ? 'open' : ''}`}>
                <div className="burger-menu-inner">
                    <div className="burger-menu-items" onClick={toggleMenu}>
                        {props.renderNavLinks()}
                    </div>
                    <button className="burger-menu-button" onClick={toggleMenu}>Signup/Login</button>
                </div>
            </div>
        </>
    );
};

export default BurgerMenu;